import React, { useEffect, useState } from 'react'
import { Badge, Box, IconButton, Popover } from '@mui/material'
import NotificationsIcon from '@mui/icons-material/Notifications'
import Notifications from '../notifications'
import styles from './NotificationsNavbar.module.scss'
import instance from '../../../providers/axios.config'
import { useDispatch, useSelector } from 'react-redux'
import { setCountNotifications } from '../../../redux/reducers/notificationsReducer'
import { RootState } from '../../../redux/reducers/rootReducer'
import { typeResponse } from '../../../utils/types'
import { useLocation } from 'react-router-dom'

interface INotificationsResponse extends typeResponse {
  data: {
    unreads: number
  }
}

export const NotificationsNavbar = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const dispatch = useDispatch()
  const location = useLocation()

  const notificationCount = useSelector(
    (state: RootState) => state.notifications.count
  )

  const fetchNotificationNumber = async () => {
    try {
      const res = await instance.get(`notifications/status`) as INotificationsResponse
      dispatch(setCountNotifications(res.data?.unreads))
    } catch (e) {
      console.error('Error fetch:', e)
    }
  }

  useEffect(() => {
    fetchNotificationNumber()
  }, [])

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'notifications-popover' : undefined

  const isActive = location.pathname.startsWith('/notifications')

  return (
    <div className={styles.container}>
      <IconButton
        id="notifications-button"
        aria-controls={open ? 'notifications-popover' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        aria-label="Notifications"
        onClick={handleClick}
        className={`${styles.iconButton} ${isActive ? styles.active : ''}`}
      >
        <Badge 
          badgeContent={notificationCount} 
          color="error"
          max={99}
          classes={{
            badge: styles.badge
          }}
        >
          <NotificationsIcon className={`${styles.icon} ${isActive ? styles.active : ''}`} />
        </Badge>
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        classes={{
          paper: styles.popoverPaper
        }}
        // Prevent nested scroll issues
        disableScrollLock={false}
      >
        <Box className={styles.popoverContent}>
          <Notifications isHeader />
        </Box>
      </Popover>
    </div>
  )
}

export default NotificationsNavbar